<template lang="html">
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <a href="https://github.com/gongzza/fixture-factory">
          <i class="fab fa-github fa-2x"></i>
        </a>
        <p><b>Made with:</b></p>
        <p>
          <a href="https://kr.vuejs.org/">
            <span class="tag">Vue.js</span>
          </a>
          <a href="https://rawgit.com/Marak/faker.js/master/examples/browser/index.html">
            <span class="tag">Faker.js</span>
          </a>
          <a href="https://bulma.io">
            <span class="tag">Bulma</span>
          </a>
          <a href="http://momenjs.com">
            <span class="tag">Moment.js</span>
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/layout/AppFooter.vue